import api from './api';

export const requestLoginCode = async (email) => {
  const { data } = await api.post('/auth/email/request', { email });
  return data;
};

export const verifyLoginCode = async (email, code) => {
  const { data } = await api.post('/auth/email/verify', { email, code });
  return data;
};

export const requestRegistrationCode = async (email, username, referrerId) => {
  const payload = { email, username };
  if (referrerId !== undefined && referrerId !== null && referrerId !== '') {
    payload.referrer_id = Number(referrerId);
  }
  const { data } = await api.post('/auth/register/request', payload);
  return data;
};

export const verifyRegistrationCode = async (email, code) => {
  const { data } = await api.post('/auth/register/verify', { email, code });
  return data;
};

export const getProfile = async () => {
  const { data } = await api.get('/users/me/profile');
  return data;
};

export const updateProfile = async (changes) => {
  const { data } = await api.patch('/users/me', changes);
  return data;
};

export const getReferrals = async () => {
  const { data } = await api.get('/users/me/referrals');
  return data;
};

export const getWebsiteConfig = async () => {
  const { data } = await api.get('/config');
  return data;
};

export const getConnectionStatus = async () => {
  const { data } = await api.get('/connection/status');
  return data;
};
